import { z } from 'zod';

export const propertyEditorPathSchema = z.object({
  propertyId: z.coerce.number().int().positive(),
});

export type PropertyEditorPath = z.infer<typeof propertyEditorPathSchema>;
